<template>
  <div id="personal">
    <div class="item info">
      <div class="base-info">

        <img class="avatar" :src="userInfo.avatar || require('@/assets/images/personal/avatar.png')" alt="头像">
        <div>
          <p class="nickname">{{userInfo.nickname || ''}}
            <span @click="toView('/identify')">
              <img :src="userInfo.is_verified? require('@/assets/images/personal/renzheng.png') : require('@/assets/images/personal/no-renzheng.png')" alt="认证">
              {{userInfo.is_verified ? '已认证' : '未认证 >'}}
            </span>
          </p>
          <span class="related-icon">
            <img :src="userInfo.is_vip? require('@/assets/images/personal/vip.png') : require('@/assets/images/personal/no-vip.png')" alt="会员">
            {{userInfo.is_vip ? '已成为会员' : '未成为会员 >'}}
          </span>
        </div>
        <span @click="toView('/identify')" v-if="!userInfo.is_verified">去认证 <span class="right_arrows"></span></span>
      </div>
      <div class="menu">
        <div @click="toView('/planList')">
          <img src="@/assets/images/personal/fangan.png" alt="">
          <span>我的方案</span>
        </div>
        <div @click="toView('/allPolicy')">
          <img src="@/assets/images/personal/baodan.png" alt="">
          <span>全部保单</span>
        </div>
        <div @click="toView('/serviceProgress')">
          <img src="@/assets/images/personal/jindu.png" alt="">
          <span>服务进度</span>
        </div>
      </div>
    </div>
    <div class="item purchase">
      <div class="row" v-if="!userInfo.is_vip">
        <div class="pic">
          <img src="@/assets/images/personal/purchase.png" alt="">
        </div>
        <div class="intro">
          <p>购买家庭保障计划</p>
          <p>专业保险精算师为您定制专属计划</p>
        </div>
        <button @click="toView('/')">去购买</button>
      </div>
      <!--提示关注公众号  -->
      <!-- <div class="row" v-if="!userInfo.is_followed">
        <div class="pic">
          <img src="@/assets/images/personal/gongzhonghao.png" alt="">
        </div>
        <div class="intro">
          <p>关注公众号查收方案和保单</p>
          <p>获取方案、保单等服务状态</p>
        </div>
        <button @click="toFollow">去关注</button>
        <img class="hand" src="@/assets/images/personal/hand.gif" alt="" />
      </div> -->
    </div>
    <div class="item members">
      <div class="title">
        <span>我的家庭成员</span>
        <span @click="toView('/familyMemberList')">查看全部<i class="right_arrows1"></i> </span>
      </div>
      <div class="member-list">
        <div class="block"
          v-for="(item, index) in familyMembers" :key="index" @click="toMemberInfo(item.id)">
          <img :src="require(`@/assets/images/personal/${avatarFomatter(item.role)}.png`)">
          <p class="bottom">{{item.role_label}}</p>
        </div>
        <div class="block" @click="toMemberInfo('')">
          <img src="@/assets/images/personal/add.png" alt="">
          <p class="bottom">添加</p>
        </div>
      </div>
      <div class="tip" v-if="!userInfo.has_need_info">
        <p>您购买的{{product_name}}<br>还未填写测试信息</p>
        <button @click="toView('/familyInfo')">立即填写</button>
      </div>
    </div>
    <div class="item members">
      <div class="title">
        <span>我的风险测试报告</span>
        <span>查看报告<i class="right_arrows1"></i></span>
      </div>
      <div class="ing">
        敬请期待...<br>
      </div>
      <div class="member-list" v-if="false">
        <div class="block">
          <img src="@/assets/images/personal/male.png" alt="">
          <p class="bottom">本人</p>
        </div>
        <div class="block">
          <img src="@/assets/images/personal/add.png" alt="">
          <p class="bottom">添加</p>
        </div>
      </div>
      <div class="tip" v-if="false">
        <p>您还未进行风险测试</p>
        <button>AI智能测评</button>
      </div>
    </div>
    <!-- <div class="item about" @click="toView('/aboutUs')">
      <span>
        <img src="@/assets/images/personal/about.png" alt="">
        关于锦鲤保
      </span>
      <img src="@/assets/images/personal/right-arrow.png" alt="">
    </div> -->
    <div></div>
    <van-overlay :show="focusGZH">
      <div class="focus-wrapper">
        <div class="block">
          <img class="close" src="@/assets/images/plan/close.png" alt="关闭" @click="closeOverlay">
          <div class="content">
            <p>长按二维码关注公众号</p>
            <img style="position:releative;display:block" src="@/assets/images/common/code.jpg" alt="锦鲤好运保">
            <span>用于查收您的方案和保单</span>
          </div>
        </div>
      </div>
    </van-overlay>
    <!-- <van-overlay :show="showgototime" >
      <div class="focus-wrapper">
        <div class="wrapaco">
          <img class="showgototime" src="@/assets/images/personal/showgototime.png" />
          <span class="closetop" @click="closewrite"></span>
          <span class="gotime" @click="gotowrite"></span>
        </div>
      </div>
    </van-overlay> -->
    <van-overlay :show="showgotover || showgototime" >
      <div v-if="showgotover" class="focus-wrapper">
        <div class="wrapaco">
          <img class="showgotover" src="@/assets/images/personal/showgotover.png" />
          <span class="closetop" @click="closeper"></span>
          <span class="gotime" @click="gotoper"></span>
        </div>
      </div>
      <div v-if="showgototime" class="focus-wrapper">
        <div class="wrapaco">
          <img class="showgototime" src="@/assets/images/personal/showgototime.png" />
          <span class="closetop" @click="closewrite"></span>
          <span class="gotime" @click="gotowrite"></span>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
// 个人中心
export default {
  name: 'personal',
  data() {
    return {
      userInfo: {},
      familyMembers:[],
      focusGZH: false,
      product_name:'',
      showgototime:false,//预约
      showgotover:false,//认证
      show1:true
    }
  },
  methods: {
    closeper(){
      this.showgotover = false;
      if(this.Storage.get('showgotover')){
        var showgotove1 = Number(this.Storage.get('showgotover')) + 1;
        this.Storage.set('showgotover',showgotove1);
      }else{
        this.Storage.set('showgotover',1);
      }
      this.Storage.session.set('nowover',1)
    },
    gotoper(){
      this.$router.push('/familyInfo')
    },
    closewrite(){
      this.showgototime = false;
      if(this.Storage.get('showgototime')){
        var showgototim1 = Number(this.Storage.get('showgototime')) + 1;
        this.Storage.set('showgototime',showgototim1);
      }else{
        this.Storage.set('showgototime',1);
      }
      this.Storage.session.set('nowwrite',1)
    },
    gotowrite(){
      this.$router.push('/Appointment')
    },
    // 获取用户信息
    getUserInfo() {
      this.axios({
        method: 'GET',
        url: '/user',
        headers: {
          'Authorization': `Bearer ${this.Global.getCookie('token')}` 
        }
      }).then((res) => {
        if(res.data.code == 0){
          this.userInfo = res.data.data
          this.product_name = res.data.data.vip_info.product_name
          if(this.Storage.session.get('denglu')){
            this.showgototime = false;
            // console.log('fas')
          }else{
            // console.log('tru',this.Storage.session.get('denglu'))
            this.Storage.set('userBaseInfo', res.data.data)
            this.Storage.session.set('denglu',true);//已经在页面内了
            if(!this.Storage.get('showgotover')){
              this.Storage.set('showgotover',0)
            }
            if(!this.Storage.get('showgototime')){
              this.Storage.set('showgototime',0)
            }
            // console.log(this.Storage.get('showgotover')) !userInfo.has_need_info
            if(!res.data.data.has_need_info && Number(this.Storage.get('showgotover'))<6 && !this.Storage.session.get('nowover')){ //提示填写信息
              this.showgotover = true;
            }
            if(!res.data.data.is_appointed && Number(this.Storage.get('showgototime'))<6 && !this.Storage.session.get('nowwrite')){
              this.showgototime = true;//提示预约
            }
          }
        }
      })
    },
    // 获取家庭成员信息
    getFamilyMembers(){
      this.axios({
        method: 'GET',
        url: '/user-family?need=id,role,role_label',
        headers: {
          'Authorization': `Bearer ${this.Global.getCookie('token')}` 
        }
      }).then((res) => {
        if(res.data.code == 0){
          this.familyMembers = res.data.data
        }
      })
    },
    // 生成对应头像
    avatarFomatter(role){
      switch (role){
        case 1:
          return this.userInfo.gender == 1 ? 'male' : 'female'
        case 2:
          return this.userInfo.gender == 1 ? 'female' : 'male'
        case 3:
          return 'son'
        case 4:
          return 'daughter'
        case 5:
          return 'father'
        case 6:
          return 'mother'
        case 7:
          return 'father'
        case 8:
          return 'mother'
        default:
          return `other`
      }
    },
    // 跳转
    toView(route){
      this.$router.push(route)
    },
    toMemberInfo(memberId){
      if(memberId){
        this.$router.push({
          path:'/memberInfo',
          query: {
            memberId,
            from:'/personal'
          }
        })
      }else{
        this.$router.push({
          path:'/memberInfo',
          query:{
            from:'/personal'
          }
        })
      }
    },
    // 关注公众号，暂时没有用跳转的方式了，改为弹出二维码
    toFollow(){
      this.focusGZH = true
      // window.location.href = 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzI0NzA1MTE0MQ==&scene=124#wechat_redirect'
    },
    // 关闭弹窗
    closeOverlay(){
      this.focusGZH = false
      this.getUserInfo()
    }
  },
  created(){
    
    this.getUserInfo()
    this.getFamilyMembers()
    this.Global.getShareConfig({
      title: '点击获取私人家庭保障方案',
      desc: '一对一咨询，分析风险，定制保障方案，让你买的放心，保的全面'
    },this)
    
  }
}
</script>

<style scoped>
.hand{
  position: absolute;
  width: 1.5rem;
  right: 0;
  bottom: 0.5rem;
}
.wrapaco{
  position: relative;
  margin: 0 auto;
  width: 19rem;
  height: 21rem;
}
.closetop{
  position: absolute;
  right: 0.8rem;
  top: 0.8rem;
  width: 1.5rem;
  height: 1.5rem;
}
.gotime{
  position: absolute;
  bottom: 1.5rem;
  width: 6.5rem;
  height: 2.5rem;
  left: 0;
  right: 0;
  margin: auto;
}
.showgotover{
  width: 19rem;
}
.members,.about{
  padding:  0 1rem;
}
.right_arrows {
    width: 0.22rem;
    height:0.22rem;
    border-top: 0.02rem solid rgba(255,161,39,1);;
    border-right: 0.02rem solid rgba(255,161,39,1);
    display: inline-block;
    transform: rotate(45deg);
    margin-left: 0.25rem;
}
.right_arrows1 {
    width: 0.42rem;
    height:0.42rem;
    border-top: 0.02rem solid rgba(131,132,144,1);
    border-right: 0.02rem solid rgba(131,132,144,1);
    display: inline-block;
    transform: rotate(45deg);
    margin-left: 0.25rem;
}
  #personal{
    background: #F3F3F3;
    padding-bottom: 0.5rem;
  }
  .item{
    background: #FFF;
    margin-bottom: 0.5625rem;
  }
  
  .item.info > div{
    display: flex;
  }
  .item.info .base-info{
    height:5.5rem;
    background:rgba(255,161,39,1);
  }
  .item.info .base-info .avatar{
    border-radius: 50%;
    width: 3rem;
    height: 3rem;
    margin: 1.69rem 0.69rem 0 1.69rem;
    padding: 0.1rem;
    border: 0.05rem solid white;
  }
  .item.info .base-info div{
    flex: 1;
  }
  .item.info .base-info div .nickname{
    font-size: 1.25rem;
    font-weight: 600;
    height:1.69rem;
    margin-top: 1.6rem;
    color:rgba(255,255,255,1);
  }
  .item.info .base-info div .related-icon{
    font-size: 0.7rem;
    color: #fff;
    display: inline-flex;
    align-items: center;
    padding: 0.03rem 0.75rem;
    background:rgba(254,134,0,1);
    border-radius: 4rem;
  }
  .item.info .base-info div .related-icon > img:first-child{
    width: 0.59rem;
    margin-right: 0.42rem;
  }
  .item.info .base-info div p span{
    font-size: 0.7rem;
    display: inline-flex;
    align-items: center;
    color: #ffffff;
  }
  .item.info .base-info div p span img{
    width: 0.59rem;
    margin-right: 0.2rem;
  }
  
  .base-info>span{
    display: inline-block;
    margin-top: 2.38rem;
    width: 4.06rem;
    height: 1.56rem;
    border-radius:4rem 0rem 0rem 4rem;
    background:rgba(254,234,209,1);
    font-size:0.63rem;
    text-indent: 0.94rem;
    line-height: 1.56rem;
    color:rgba(255,161,39,1);
    display: flex;
    align-items: center;
  }
  .item.info .menu{
    height: 6.56rem;
    justify-content: space-around;
  }
  .item.info .menu div{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 1.44rem;
  }
  .item.info .menu div img{
    width: auto;
    height: 1.98rem;
  }
  .item.info .menu div span{
    font-size: 0.88rem;
    font-weight: 400;
    color:rgba(49,52,71,1);
    margin-top: 0.63rem;
    height: 1.25rem;
  }
  .item.purchase{
    padding: 0 1rem;
  }
  .item.purchase .row{
    display: flex;
    align-items: center;
    position: relative;
    padding: 0.875rem 0;
  }
  .item.purchase .row .pic{
    width: 2.9375rem;
    height: 2.3125rem;
    text-align: center;
    margin-right: 0.75rem;
  }
  .item.purchase .row .pic img{
    width: auto;
    height: 100%;
  }
  .item.purchase .row .intro{
    line-height: 1.5rem;
  }
  .item.purchase .row .intro p:first-child{
    font-size: 1rem;
    font-weight: 500;
    color: #4D4D4D;
  }
  .item.purchase .row .intro p:last-child{
    font-size: 0.8125rem;
    font-weight: 400;
    color: #979797;
  }
  .item.purchase .row button{
    background:rgba(255,161,39,1);
    color: #FFF;
    font-size: 0.875rem;
    font-weight: 500;
    text-align: center;
    border-radius: 1rem;
    width: 4rem;
    height: 1.8125rem;
    line-height: 1.8125rem;
    position: absolute;
    right: 0;
  }
  .item.members .title{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1.125rem 0;
  }
  .item.members .title span:first-child{
    padding-left: 0.625rem;
    position: relative;
    color: #4D4D4D;
    font-size: 1rem;
    font-weight: 600;
  }
  .item.members .title span:first-child::before{
    content: '';
    width: 0.1875rem;
    height: 0.8125rem;
    background:rgba(49,52,71,1);
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    margin-top: auto;
    margin-bottom: auto;
  }
  .item.members .title span:last-child{
    color:rgba(131,132,144,1);
    font-size: 0.75rem;
    font-weight: 500;
    display: flex;
    align-items: center;
  }
  .item.members .member-list{
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  .item.members .member-list .block{
    position: relative;
    width: 3.625rem; 
    height: 3.625rem;
    border-radius: 0.3125rem;
    overflow: hidden;
    margin: 0 2rem 1rem 0;
  }
  .item.members .member-list .block:nth-child(4n){
    margin-right: 0;
  }
  .item.members .member-list .block:nth-child(4n+1){
    margin-left: 0.5rem;
  }
  .item.members .member-list .block .bottom{
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 1rem;
    line-height: 1rem;
    background:rgba(255,161,39,0.88);
    font-size: 0.75rem;
    font-weight: 500;
    color: #FFF;
    text-align: center;
  }
  .item.members .tip{
    text-align: center;
  }
  .item.members .tip p{
    color: #979797;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1rem;
  }
  .item.members .tip button{
    background:rgba(255,161,39,1);
    box-shadow: 0 0.1875rem 0.25rem 0 rgba(255,131,47,0.2);
    border-radius: 1.0625rem;
    padding: 0 1.0625rem;
    height: 2.1875rem;
    line-height: 2.1875rem;
    font-size: 0.875rem;
    font-weight: 500;
    color: #FFF;
    letter-spacing: 0.0625rem;
    margin: 1rem 0 1.1875rem;
  }
  .item.members .ing{
    padding: 10.9375rem 0.3125rem 1.5625rem;
    text-align: center;
    line-height: 1.25rem;
    background: url(../assets/images/common/404.png) no-repeat center;
    background-size: 50%;
    color: #979797;
  }
  .item.about{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .item.about span{
    display: flex;
    align-items: center;
    color: #7C7C7C;
    font-size: 0.875rem;
    font-weight: 400;
  }
  .item.about span img{
    width: 1.0625rem;
    margin-right: 0.8125rem;
  }
  .item.about > img{
    width: 0.5rem;
  }

  .focus-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .focus-wrapper .block {
    width: 19rem;
    height: 23rem;
    background: url(../assets/images/plan/overlay-bg.png) no-repeat;
    background-size: 100%;
    position: relative;
    border-radius: 0.5625rem;
  }
  .focus-wrapper .block .close{
    width: 1.75rem;
    position: absolute;
    top: -2.125rem;
    right: -1.25rem;
  }
  .focus-wrapper .block .content {
    text-align: center;
  }
  .focus-wrapper .block .content p{
    font-size: 1.1875rem;
    padding-top: 3.75rem;
  }
  .focus-wrapper .block .content img{
    width: 12.5rem;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    bottom: -2.5rem;
  }
  
</style>